import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Box from '../Box';

var TableWrapper = function TableWrapper(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    shrink: 1,
    grow: 1
  }, props));
};

export default TableWrapper;